import { MainCategories } from "../MainCategories";

export enum ExecuteProcessEvent {
  StartExecuteProcess = MainCategories.ExecuteProcess + "StartExecuteProcess",
  FinishExecuteProcess = MainCategories.ExecuteProcess + "FinishExecuteProcess",
}
